export default "__VITE_ASSET__CorOCQc2__"